<template>
  <div class="overlay">
    <div class="header">
      <div>
        <a href="#" class="go-back" @click.stop="closePreview">
          <span class="icon icon-arrow-left3"></span>
          Go Back
        </a>
        {{ templateEmail.email.name }}
      </div>
      <button type="button" class="xpl-button xpl-button--primary" @click.stop="selectTemplate">Use This Template</button>
    </div>
    <div class="preview">
      <div v-html="preview_html"></div>
    </div>
  </div>
</template>
<script>
  import EventBus from '@/event-bus';
  import * as api from '@/api';

  export default {
    props: ['template', 'templateEmail'],
    data() {
      return {
        preview_html: null,
      };
    },
    created() {
      const payload = {
        type: this.templateEmail.email.type,
        uuid: this.templateEmail.email.uuid,
        // stupid bug, please solve
        payload: JSON.stringify(JSON.parse(this.templateEmail.email.body)),
      };

      api.getTemplatePreview(payload).then((response) => {
        this.preview_html = response.html;
      }).catch((err) => {
        this.$toasted.error(err.message);
      });
    },
    methods: {
      closePreview() {
        EventBus.$emit('campaign_template.email.preview.close');
      },
      selectTemplate() {
        EventBus.$emit('campaign_template.email.preview.select', this.template);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #f3f7f9;
    z-index: 10000;
    overflow: hidden;
  }

  .header {
    height: 3rem;
    background-color: #ffffff;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: .5rem;
    padding-bottom: .5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #cdd7e2;
    font-weight: 700;
    line-height: 1.5rem;
    color: #1d364b;
  }

  .header .icon {
    font-size: .75rem;
    margin-right: .25rem;
  }

  .header .go-back {
    margin-right: 1rem;
    color: #586777;
  }

  .preview {
    height: 100%;
    padding-top: 2rem;
    padding-bottom: 4rem;
    overflow-x: scroll;
  }
</style>
